import React from 'react';
import styles from './styles.module.scss';
import { UserBonusCardCheckpointsProps } from '../../props';
import UserBonusCheckpointsV2Render from './Stepper';
import useTranslation from 'next-translate/useTranslation';
import UserBonusCardCheckpointsV2Skeleton from './Skeleton';
import { useLanguageDictionary } from '@/hooks/useLanguageDictionary';
import { I18n } from '@/services/I18n';

export default function UserBonusCardCheckpointsV2({
  userBonus,
  curretCheckpointIndex,
  isLoading,
}: UserBonusCardCheckpointsProps) {
  const { t } = useTranslation('bonus');
  const nameI18n: I18n = useLanguageDictionary(userBonus?.bonus?.name);

  if (isLoading) {
    return <UserBonusCardCheckpointsV2Skeleton />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__description}>
        {t('user_bonus_checkpoint_description', {
          name: nameI18n.t(),
        })}
      </div>
      <UserBonusCheckpointsV2Render
        checkpoints={userBonus?.checkpoints}
        userBonus={userBonus}
        currentCheckpointIndex={curretCheckpointIndex}
      />
    </div>
  );
}
